import * as config from '../config'
import {Align} from "../class/align";

export default class Deadline {
    constructor(scene, group) {
        this.scene = scene;
        this.groupDeadline = group;
        this.dbDeadline = {
            lastUpdate: null
        };
        this.deadline = this.scene.deadline = this.scene.physics.add.sprite(0,0,'deadline')
        this.deadline.setDisplaySize(config.width, config.height);
        this.deadline.y -= this.deadline.displayHeight / 2;
        Align.centerWidth(this.deadline);
        this.moveTo = scene.plugins.get('rexMoveTo').add(this.deadline, {
            speed: 400,
        });
    }

    update() {
        let date = new Date();
        if (!this.dbDeadline.lastUpdate || date >= this.dbDeadline.lastUpdate) {
            let newY = this.deadline.y + config.projectile.deadline.speed;
            this.moveTo.moveTo(this.deadline.x, newY);
            this.groupDeadline.add(this.deadline);
            this.dbDeadline.lastUpdate = date.setSeconds(date.getSeconds() + 1)
        }
    }
}
